import classNames from 'classnames';
import React from 'react';

import { TextProvider } from '../TextProvider';

interface ExpectedDeliveryDateNoPostalCodeInfoProps {
    isCooledProduct: boolean;
    openModal: () => void;
    cooledDeliveryInfoPage: string;
}

export const ExpectedDeliveryDateNoPostalCodeInfo = (props: ExpectedDeliveryDateNoPostalCodeInfoProps) => {
    return (
        <div
            className={classNames(
                'ExpectedDeliveryDateView__HeaderDeliveryInfoWrapper',
                props.isCooledProduct
                    ? 'ExpectedDeliveryDateView__HeaderDeliveryInfoWrapper--NoPostalCodeCooledProduct'
                    : 'ExpectedDeliveryDateView__HeaderDeliveryInfoWrapper--NoPostalCode'
            )}
        >
            <div
                className={classNames('ExpectedDeliveryDateView__InfoWrapper', props.isCooledProduct && 'ExpectedDeliveryDateView__InfoWrapper--CooledProduct')}
            >
                <span
                    className={classNames(
                        'ExpectedDeliveryDateView__HeaderDeliveryInfo',
                        props.isCooledProduct && 'ExpectedDeliveryDateView__HeaderDeliveryInfo--CooledProduct'
                    )}
                >
                    {props.isCooledProduct ? TextProvider.expectedDeliveryDate.cooledProductDelivery : TextProvider.expectedDeliveryDate.delivery}
                </span>
                <span className="ExpectedDeliveryDateView__EnterPostalCode">
                    {props.isCooledProduct ? TextProvider.expectedDeliveryDate.cooledProductDeliveryInfo : TextProvider.expectedDeliveryDate.deliveryToInfo}
                </span>
            </div>

            <div className="ExpectedDeliveryDateView__CoolProductsButtons">
                {props.isCooledProduct && (
                    <a
                        href={props.cooledDeliveryInfoPage}
                        rel="noreferrer noopener"
                        target="_blank"
                        className="Button Button--Small Button--Link ExpectedDeliveryDateView__LinkButton ExpectedDeliveryDateView__LinkButton--CooledProduct"
                    >
                        {TextProvider.expectedDeliveryDate.moreAboutCooledDelivery}
                    </a>
                )}
                <button onClick={props.openModal} className="Button Button--XSmall ExpectedDeliveryDateView__ChangeButton--NoPostalCode">
                    {TextProvider.expectedDeliveryDate.checkDelivery}
                </button>
            </div>
        </div>
    );
};
